import React, { useEffect, useState } from "react";
import { Container, Row, Col, Card } from "react-bootstrap";
import { Link, useLocation } from "react-router-dom";
import { accessories_array } from "./accessoriesdata";
import "./Accessories.scss";
import MetaInformation from "../../utils/meta/MetaInformation";
import { activeTabHandler } from "./findActiveTab";

const Accessories = () => {
  const [activeTab, setActiveTab] = useState(accessories_array[0].type);
  const [accessoryArr, setAccessoryArr] = useState(
    accessories_array[0].instruments
  );
  const location = useLocation().state;

  const activeHandler = (event) => {
    setActiveTab(activeTabHandler(event.target.innerText));
  };

  useEffect(() => {
    location?.type && setActiveTab(location.type);
    // 👇️ scroll to top on page load
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, []);

  // active tab value is passed in state of link so
  // that array can be filtered based on it in accessoriesInfo module

  const accessoryFiltered = () => {
    return accessories_array.filter((state) => state.type === activeTab);
  };

  useEffect(() => {
    accessories_array.map(
      (state) => state.type === activeTab && setAccessoryArr(state.instruments)
    );
  }, [activeTab]);
  // Above useEffect is filtering the value on the basis of active tab

  return (
    <>
      <MetaInformation
        title="Accesseries - HERZMANN"
        name="Accessories route"
        content="Showing accessories accoring to types"
      />
      <main className="Accessories_Main">
        <Container fluid="lg">
          <Row>
            <Col className="text-center p-md-3">
              <h2>Accessories</h2>
              <div className="mt-4 d-flex justify-content-center gap-lg-5 gap-2 flex-wrap">
                {accessories_array?.map((state) => (
                  <button
                    key={state.type}
                    value={state.type}
                    className={activeTab === state.type ? "Active-tab" : ""}
                    onClick={activeHandler}
                  >
                    {state.type}
                  </button>
                ))}
              </div>
              <article>
                {accessoryArr?.map((state, index) => {
                  return (
                    <Link
                      to={`${state?.title
                        .split(/[-\s]+/)
                        .join("-")
                        .toLowerCase()}`}
                      state={{
                        filteredArray: accessoryFiltered(),
                        from: "accessories",
                        title: state?.title,
                      }}
                      key={index}
                      className="rounded"
                    >
                      <Card>
                        <span>
                          <img
                            src={state.image}
                            alt="instrument"
                            className={
                              state.title === "Critical Area Bed Head Units" ||
                              state.title === "Patient Bed Head Units"
                                ? "bed-units"
                                : ""
                            }
                          />
                        </span>
                        <p>{state.title}</p>
                      </Card>
                    </Link>
                  );
                })}
              </article>
            </Col>
          </Row>
        </Container>
      </main>
    </>
  );
};

export default Accessories;
